(function () {
	'use strict';

	angular
		.module('wizard-future7.services')
		.service('UnitService', UnitService);

	function UnitService(HttpService, ROUTES) {
		const UnitService = {
			getUnitsStates,
			getUnitsCities,
			getUnits,
			getUnitsByCity
		};

		return UnitService;

		function getUnitsStates() {
			return HttpService.get('/units/states');
		}

		function getUnitsCities(stateName) {
			return HttpService.get(`/units/states/${stateName}`);
		}

		function getUnits(cityId, leads = false, setTest = localStorage.getItem('setTeste') || false) {
			return HttpService.getExternal(`${ROUTES.API_GROWTH}/units/cities/${cityId}/${setTest}`);
		}

		function getUnitsByCity(city) {
			return HttpService.get(`/units/cities/${city}`);
		}
	}
})();